import React, { useState } from 'react'
import { Image, Link } from 'newComponents'
import share from '../../../images/blog/share.svg'
import facebook from '../../../images/blog/facebook.svg'
import linkedIn from '../../../images/blog/linkedIn.svg'
import twitter from '../../../images/blog/twitter-share.svg'
import copyLink from '../../../images/blog/copy-link.svg'
import './styles.scss'

const Share = ({ location, title, id }) => {
  const { pathname } = location
  const rootUrl = `https://launchdarkly.com${pathname}`

  // state
  const [linkCopied, setLinkCopied] = useState(false)

  // copy to clipboard
  const copyText = (text) => {
    const input = document.createElement('textarea')
    input.innerHTML = text
    document.body.appendChild(input)
    input.select()
    const result = document.execCommand('copy')
    document.body.removeChild(input)
    return result
  }

  // handle link copy
  const copyTextHandler = (event, text) => {
    event.preventDefault()
    if (!text) return null
    copyText(text)
    setLinkCopied(true)
    setTimeout(() => setLinkCopied(false), 2000)
  }

  const shareLinks = [
    { name: 'Twitter', link: `https://twitter.com/intent/tweet?url=${rootUrl}&text=${title}`, icon: twitter },
    {
      name: 'Facebook',
      link: `https://www.facebook.com/sharer/sharer.php?u=${rootUrl}`,
      icon: facebook
    },
    {
      name: 'LinkedIn',
      link: `https://www.linkedin.com/shareArticle?mini=true&url=${rootUrl}&title=${title}`,
      icon: linkedIn
    },
    {
      name: `${linkCopied ? 'Copied!' : 'Copy Link'}`,
      onClick: (event) => copyTextHandler(event, rootUrl),
      icon: copyLink
    }
  ]

  return (
    <section className="share-actions" id={id || ''}>
        <Image className="share-actions-icon" image={share} />
        <div className="share-actions-links-container">
          {shareLinks.map((link) => {
            const { name, link: href, icon, onClick } = link
            return (
              <div className="share-actions-link-container" key={name}>
                <Image className="share-actions-link-icon" image={icon} />
                <a href={href || '#'} onClick={onClick || (() => {})} target="__blank" className="share-actions-link">
                  {name}
                </a>
              </div>
            )
          })}
        </div>
    </section>
  )
}
export default Share
